/*
 * WOOF Countdown Banner
 * <woof-countdown-banner> — drives the promo bar's live countdown.
 *
 * The countdown always targets the *next midnight in Europe/Amsterdam*, so it
 * counts down through the day and automatically resets to 23:59:59 once a new
 * Amsterdam day begins. It re-reads the Amsterdam wall clock every tick, so it
 * is DST-safe (CET/CEST) and self-correcting.
 */
(function () {
  const AMSTERDAM = 'Europe/Amsterdam';
  const SECONDS_PER_DAY = 86400;

  class WoofCountdownBanner extends HTMLElement {
    connectedCallback() {
      this.elDays = this.querySelector('[data-woof-cd-days]');
      this.elHours = this.querySelector('[data-woof-cd-hours]');
      this.elMinutes = this.querySelector('[data-woof-cd-minutes]');
      this.elSeconds = this.querySelector('[data-woof-cd-seconds]');

      this._tick = this._tick.bind(this);
      this._tick();
      this._interval = window.setInterval(this._tick, 1000);
    }

    disconnectedCallback() {
      if (this._interval) window.clearInterval(this._interval);
    }

    // Seconds elapsed since midnight, read from the Amsterdam wall clock.
    _amsterdamSecondsElapsed() {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: AMSTERDAM,
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }).formatToParts(new Date());

      let h = 0;
      let m = 0;
      let s = 0;
      for (const part of parts) {
        if (part.type === 'hour') h = parseInt(part.value, 10) % 24; // guard against "24"
        else if (part.type === 'minute') m = parseInt(part.value, 10);
        else if (part.type === 'second') s = parseInt(part.value, 10);
      }
      return h * 3600 + m * 60 + s;
    }

    _tick() {
      let left = SECONDS_PER_DAY - this._amsterdamSecondsElapsed();
      // At the exact midnight instant this equals a full day; clamp so the bar
      // shows 23:59:59 rather than flashing "1 day / 24:00:00".
      if (left > SECONDS_PER_DAY - 1) left = SECONDS_PER_DAY - 1;
      if (left < 0) left = 0;

      const days = Math.floor(left / SECONDS_PER_DAY);
      const hours = Math.floor(left / 3600) % 24;
      const minutes = Math.floor(left / 60) % 60;
      const seconds = left % 60;

      const pad = (n) => String(n).padStart(2, '0');
      if (this.elDays) this.elDays.textContent = pad(days);
      if (this.elHours) this.elHours.textContent = pad(hours);
      if (this.elMinutes) this.elMinutes.textContent = pad(minutes);
      if (this.elSeconds) this.elSeconds.textContent = pad(seconds);
    }
  }

  if (!customElements.get('woof-countdown-banner')) {
    customElements.define('woof-countdown-banner', WoofCountdownBanner);
  }
})();
